/* eslint-disable max-len */
const initialState = {
	allTransCriptionData : [],
	skip                 : 0,
	transcriptionOptions : {},
	finalText            : ''
};

const viewTranscription = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_ALL_TRANSCRIPTIONDATA':
		{
			const { transcriptionData } = action.payload;

			const copyData = [ ...transcriptionData, ...state.allTransCriptionData ];

			copyData.sort((a, b) => new Date(a.conversationStartTime) - new Date(b.conversationStartTime));

			return { ...state, allTransCriptionData: [ ...copyData ] };

		}
		case 'SET_REFRESH_DATA':
		{

			const { refreshTranscriptionData } = action.payload;

			refreshTranscriptionData.sort((a, b) => new Date(a.conversationStartTime) - new Date(b.conversationStartTime));

			return { ...state, allTransCriptionData: [ ...refreshTranscriptionData ] };

		}
		case 'SET_EACH_TRANSCRIPTIONDATA':
		{
			const { eachTranscription } = action.payload;

			const allText = [ ...state.allTransCriptionData ];

			allText.push(eachTranscription);

			return { ...state, allTransCriptionData: [ ...allText ] };
		}

		case 'SET_SKIP':
		{
			const { skip } = action.payload;

			return { ...state, skip };
		}

		case 'SET_TRANSCRIPTION_OPTIONS':
		{
			const { transcriptionOptions } = action.payload;

			return { ...state, transcriptionOptions };
		}

		case 'SET_FINAL_TEXT':
		{

			const { text } = action.payload;

			const copyFinalText = state.finalText;

			return { ...state, finalText: `${copyFinalText} ${text}`.trim() };

		}

		case 'REMOVE_FINAL_TEXT':
		{
			return { ...state, finalText: '' };
		}

		default:
			return state;
	}
};

export default viewTranscription;
